module.exports = __webpack_public_path__ + "img/培训.6a3f4534.png";